import type { ReactNode } from 'react'
import { InfoIcon } from 'lucide-react'
import { useFormOptionalLabel, useFormReadOnly } from './shared'
import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

export function FieldLabelRow({
  label,
  htmlFor,
  hasError,
  optional,
  compactOptional,
  info,
  className,
}: {
  label: string
  htmlFor: string
  hasError: boolean
  optional?: boolean
  compactOptional?: boolean
  info?: ReactNode
  className?: string
}) {
  const optionalLabel = useFormOptionalLabel()
  const formReadOnly = useFormReadOnly()

  return (
    <div className={cn('flex items-center justify-between gap-6', className)}>
      <div className="flex h-5 items-center gap-1">
        <Label
          data-slot="form-label"
          data-error={hasError}
          className="data-[error=true]:text-destructive"
          htmlFor={htmlFor}
        >
          {label}
          {optional === false && '*'}
        </Label>
        {info && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger
                render={
                  <button type="button" className="inline-flex" aria-label="More information">
                    <InfoIcon className="text-muted-foreground size-4" />
                  </button>
                }
              />
              <TooltipContent>{typeof info === 'string' ? <p>{info}</p> : info}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      {optional && !compactOptional && (
        <span className={cn('text-xs text-muted-foreground transition-opacity', formReadOnly && 'opacity-0')}>
          {optionalLabel}
        </span>
      )}
    </div>
  )
}
